export default __webpack_public_path__ + "static/media/CL03.9908f018.mp3";